var _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcFlowFilled = function SvgIcFlowFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 17.5,
    r: 2.5,
    fill: "#DBDE70"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 2.5,
    fill: "#DBDE70"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DBDE70",
    d: "M9 5h5.7v3.5H9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.196 9.464v2.429H7.554a1.82 1.82 0 0 0-1.822 1.821v.663a3.34 3.34 0 1 0 3.946 3.284 3.342 3.342 0 0 0-2.732-3.284v-.663a.606.606 0 0 1 .608-.607h8.5a.606.606 0 0 1 .607.607v.663A3.34 3.34 0 0 0 17.268 21a3.34 3.34 0 0 0 .607-6.623v-.663a1.82 1.82 0 0 0-1.821-1.821H12.41V9.464h1.214a1.82 1.82 0 0 0 1.821-1.821V5.82A1.82 1.82 0 0 0 13.625 4H9.982a1.82 1.82 0 0 0-1.821 1.821v1.822a1.82 1.82 0 0 0 1.821 1.821h1.214Zm6.072 6.072a2.126 2.126 0 1 1-.002 4.251 2.126 2.126 0 0 1 .002-4.251Zm-10.929 0a2.126 2.126 0 1 1-.001 4.251 2.126 2.126 0 0 1 .001-4.251Zm7.893-9.715v1.822a.606.606 0 0 1-.607.607H9.982a.606.606 0 0 1-.607-.607V5.82a.606.606 0 0 1 .607-.607h3.643a.606.606 0 0 1 .607.607Z",
    fill: "currentColor"
  })));
};
export default SvgIcFlowFilled;